import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from '@packages/router/lib/route';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
};

function Router() {
    return (
        <>
            <Route
                name={'Notifications.List'}
                exact
                path={'/notifications/:tab'}
                component={ProtectedRoute(routes$.List)}
            />
        </>
    );
}

export default Router;
